import MeetingSummaryReservation from './MeetingSummary';

export default MeetingSummaryReservation;
